import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import Home from "./components/Home";
import { initContentProtection } from "./utils/contentProtection";

function App() {
  useEffect(() => {
    // Initialize content protection (skipped for SEO bots automatically)
    initContentProtection();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
